import styled from 'styled-components';

// Define element styles for the component
const Form = styled.form`
  background: transparent;
  min-width: 270px;
  margin: auto;
  padding: 0;
`;

/**
 * Form Tier component
 * @component
 * @returns
 */
export const StyledFormTier = ({ children, className, onSubmit, id }) => {
  return (
    <Form
      className={ className }
      id={ id }
      onSubmit={ onSubmit }>
      { children }
    </Form>
  );
};